import { render, staticRenderFns } from "./CompressArrowsAltIcon.vue?vue&type=template&id=eef91916&"
import script from "./CompressArrowsAltIcon.vue?vue&type=script&lang=js&"
export * from "./CompressArrowsAltIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports